<div class="side-help">
  <button
    class="help-toggle hide-for-{{ viewPoint }}"
    [class.active]="toggle"
    (click)="toggle = !toggle"
  >{{(toggle? 'step.help.toggle.close' : 'step.help.toggle.show') | translate}}
    <i [class]="toggle? 'icon-x-circle' : 'icon-info'"></i>
  </button>
  <div [class.show]="toggle" [innerHTML]="textkey | translate"></div>
</div>
